import { render } from "./culturalMain.vue?vue&type=template&id=c9ff8148&scoped=true"
import script from "./culturalMain.vue?vue&type=script&lang=js"
export * from "./culturalMain.vue?vue&type=script&lang=js"

import "./culturalMain.vue?vue&type=style&index=0&id=c9ff8148&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ff8148"]])

export default __exports__